import { render, staticRenderFns } from "./ResultBox.vue?vue&type=template&id=3f65ea72&scoped=true&"
import script from "./ResultBox.vue?vue&type=script&lang=js&"
export * from "./ResultBox.vue?vue&type=script&lang=js&"
import style0 from "./ResultBox.vue?vue&type=style&index=0&id=3f65ea72&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f65ea72",
  null
  
)

export default component.exports